import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/index',
    name: 'index',
    component: () => import('../views/Index.vue'),
    meta: {
      title: ''
    }
  },
  {
    path: '/exitpay',
    name: 'exitpay',
    component: () => import('../views/ExitPay.vue'),
    meta: {
      title: '出场查费'
    }
  },
  {
    path: '/enter',
    name: 'enter',
    component: () => import('../views/NoLicenseEnter.vue'),
    meta: {
      title: '扫码入场'
    }
  },
  {
    path: '/prepay',
    name: 'prepay',
    component: () => import('../views/Prepay.vue'),
    meta: {
      title: '场内预付'
    }
  },
  {
    path: '/result',
    name: 'result',
    component: () => import('../views/ResultNotify.vue'),
    meta: {
      title: '入场通知'
    }
  },
  {
    path: '/queryresult',
    name: 'queryresult',
    component: () => import('../views/QueryPriceResult.vue'),
    meta: {
      title: '查费结果'
    }
  },
  {
    path: '/delay',
    name: 'delay',
    component: () => import('../views/MonthDelay.vue'),
    meta: {
      title: '车辆延期'
    }
  },
  {
    path: '*',
    name: '/',
    component: () => import('../views/AuthCodeNotify.vue'),
    meta: {
      title: ''//微信支付宝获取授权code的回调地址
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
  document.title=to.meta.title
  next()
})


export default router
